import {} from "../../request/api";
const state = {
    infoId: null,
    typeRouter: null,

    alarmDistanceList: [],
    alarmZoneList: [],
    alarmDisappearList: [],
};
const mutations = {
    changeInfoId(state, id) {
        state.infoId = id;
    },
    changetypeRouter(state, type) {
        state.typeRouter = type;
    },
    changeAlarmDistanceList(state, type) {
        state.alarmDistanceList = type;
    },
    changeAlarmZoneList(state, type) {
        state.alarmZoneList = type;
    },
    changeAlarmDisappearList(state, type) {
        state.alarmDisappearList = type;
    },

};
const actions = {};

const getters = {
    infoId(state) {
        return state.infoId;
    },
    typeRouter(state) {
        return state.typeRouter;
    },
    alarmDistanceList(state) {
        return state.alarmDistanceList;
    },
    alarmZoneList(state) {
        return state.alarmZoneList;
    },
    alarmDisappearList(state) {
        return state.alarmDisappearList;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}